module.exports = __webpack_public_path__ + "ed3cb7ce68ad0400e6411b2592a4317c.MP3";